export const SUPER_ADMIN = 'superAdmin'
export const WORKSPACE_ADMIN = 'workspaceAdmin'
export const MEMBER = 'member'
export const DOMAIN_LIST = [
    // 'pms.softwareco.com',
    'app.softwareco.com',
    'dev.softwareco.com',
    'stage.softwareco.com',
]
export const SUB_DOMAIN_LIST = [
    // 'pms.softwareco.com',
    'pmx.softwareco.com',
    'w3.softwareco.com',
    'w2.softwareco.com',
]
export const PRIVATE_ROUTE_CHECK = [
    'workspace',
    'inquiries',
    'talent',
    'marketx',
    'global-settings',
]
export const CHECK_PUBLIC_ROUTE_LOGIN = [
    'callback-url',
    'time-tracking-app',
    '/reset-password',
    '/login-with-app',
    '/boss-bot',
]

export const CHECK_SUPPORT_DOMAIN = ['support.softwareco.com']

export const CHECK_MARKET_DOMAIN = ['marketx.softwareco.com']
